const CSRF_TOKEN = () => document.querySelector('meta[name="csrf-token"]')?.content

const jsonHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-CSRF-Token': CSRF_TOKEN()
})

const parseResponse = async (response) => {
  let data = null

  try {
    data = await response.json()
  } catch {
    data = null
  }

  if (!response.ok) {
    throw new Error(data?.error || 'Request failed')
  }

  return data
}

export const fetchPermissions = async ({ resourceType, resourceId }) => {
  const qs = new URLSearchParams({
    resource_type: resourceType,
    resource_id: resourceId
  })

  const response = await fetch(`/api/permissions?${qs}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })

  return parseResponse(response)
}

export const createPermission = async (payload) => {
  const response = await fetch('/api/permissions', {
    method: 'POST',
    headers: jsonHeaders(),
    credentials: 'same-origin',
    body: JSON.stringify(payload)
  })

  return parseResponse(response)
}

export const updatePermission = async (id, payload) => {
  const response = await fetch(`/api/permissions/${id}`, {
    method: 'PATCH',
    headers: jsonHeaders(),
    credentials: 'same-origin',
    body: JSON.stringify(payload)
  })

  return parseResponse(response)
}

export const deletePermission = async (id) => {
  const response = await fetch(`/api/permissions/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', 'X-CSRF-Token': CSRF_TOKEN() },
    credentials: 'same-origin'
  })

  return parseResponse(response)
}

export const searchPermissionUsers = async (q, { resourceType, resourceId }) => {
  const qs = new URLSearchParams({
    q: q || '',
    limit: 10,
    resource_type: resourceType,
    resource_id: resourceId
  })

  const response = await fetch(`/api/permission_users?${qs}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })

  return parseResponse(response)
}

